import { Medal } from "@phosphor-icons/react";

/** Tier chip — colour comes from the tier definition so Bronze/Silver/Gold (or custom names) look consistent everywhere. */
export function TierBadge({ tier, size = "sm", testId }) {
  if (!tier) return <span className="text-[10px] text-muted-foreground" data-testid={testId}>No tier</span>;
  const cls = size === "lg" ? "px-3 py-1 text-xs" : "px-2 py-0.5 text-[10px]";
  return (
    <span className={`inline-flex items-center gap-1 rounded-full font-bold uppercase tracking-wider text-white ${cls}`} style={{ backgroundColor: tier.color || "#64748B" }} data-testid={testId}>
      <Medal size={size === "lg" ? 14 : 11} weight="fill" /> {tier.name}
    </span>
  );
}
